import CenterWrapper from '../shared/CenterWrapper.vue';
export default {
  name: 'LayoutIcon',
  components: {
    CenterWrapper
  },
  props: {
    width: {
      type: Number,
      default: 12
    },
    height: {
      type: Number,
      default: 12
    },
    color: {
      type: String,
      default: '#000000'
    }
  }
};